import React, { FC, SVGProps } from 'react';

const EyeClosed: FC<SVGProps<SVGSVGElement>> = props => (
  <svg width="21" height="21" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21" {...props}>
    <path
      d="m16.5 10.443 1.872 3.24M12.648 12.244l.583 3.31M8.345 12.243l-.584 3.31M4.496 10.44l-1.88 3.257M2.625 8.603c1.38 1.707 3.907 3.866 7.875 3.866 3.967 0 6.496-2.159 7.875-3.866"
      stroke="#343643"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EyeClosed;
